<template>
  <b-modal
    v-model="showModal"
    size="xl"
    centered
    scrollable
    body-class="row"
    footer-class="no-gutters"
    header-class="no-gutters align-items-center"
    @ok="submitActionItem"
  >
    <template #modal-header="{ close }">
      <div class="col-auto mr-auto">
        <div class="h6 my-0">Nova ação</div>
      </div>
      <select-status class="col-auto" v-model="form.status" size="sm" pill />
      <div class="col-auto">
        <b-button @click="close" variant="link-dark">
          <b-icon icon="x"></b-icon>
        </b-button>
      </div>
    </template>
    <div class="col-12">
      <form-list-actions v-model="form" :grid-mode="true" />
    </div>
    <template #modal-footer="{ cancel, ok }">
      <div class="col-auto ml-auto">
        <b-button @click="cancel" class="mr-2">Cancelar</b-button>
        <b-button @click="ok" variant="primary">Salvar</b-button>
      </div>
    </template>
  </b-modal>
</template>

<script>
import FormListActions from "@/modules/action_plans/components/Form/FormListActions.vue";
import SelectStatus from "@/modules/action_plans/components/Form/SelectStatus.vue";
import { mapActions } from "vuex";

export default {
  components: { FormListActions, SelectStatus },
  data: () => ({
    showModal: false,
    actionPlanId: null,
    parentId: null,
    planStructureId: null,
    form: {
      why: "",
      where: "",
      who: "",
      when: "",
      how: "",
      how_much: "",
      what: "",
      action_plans_how_much: [],
      who_type: "",
    },
  }),
  methods: {
    ...mapActions("action_plans", ["ActionSavePlanItem"]),
    show(actionPlanIdOrParentId, planStructureId = null) {
      this.actionPlanId = actionPlanIdOrParentId;
      this.planStructureId = planStructureId;
      this.parentId = planStructureId ? actionPlanIdOrParentId : null;
      this.form = {
        why: "",
        where: "",
        who: "",
        when: "",
        how: "",
        how_much: "",
        what: "",
        action_plans_how_much: [],
        who_type: "",
      };
      this.showModal = true;
    },
    async submitActionItem(bvModalEvt) {
      bvModalEvt.preventDefault();

      if (!this.actionPlanId && !this.parentId) return;

      try {
        if (this.parentId && this.planStructureId) {
          this.form.parent_id = this.parentId;
          this.form.plan_structure_id = this.planStructureId;
        } else {
          this.form.action_plan_id = this.actionPlanId;
        }
        await this.ActionSavePlanItem(this.form);
        this.$notifications.addNotification({
          message: "Ação salva com sucesso",
          type: "success",
        });
        this.showModal = false;
        this.$nextTick(() => this.$emit("saved"));
      } catch (error) {
        this.$notifications.addNotification({
          message: "Erro ao salvar a ação",
          type: "danger",
        });
      }
    },
  },
};
</script>
